import React from "react";

export const ANIM_PROPS = new Set([
  "initial",
  "animate",
  "transition",
  "whileInView",
  "whileHover",
  "whileTap",
  "exit",
  "variants",
  "viewport",
  "onAnimationComplete",
  "layout",
  "layoutId",
]);

export function stripAnimProps(props: Record<string, unknown>) {
  const out: Record<string, unknown> = {};
  for (const k in props) {
    if (!ANIM_PROPS.has(k)) (out as Record<string, unknown>)[k] = props[k];
  }
  return out as Record<string, unknown>;
}

export type FMModule = {
  motion?: Record<string, React.ComponentType<unknown>>;
  AnimatePresence?: React.ComponentType<unknown>;
} | null;

export const TAGS = [
  "div",
  "nav",
  "section",
  "header",
  "footer",
  "main",
  "article",
  "aside",
  "p",
  "span",
  "ul",
  "li",
  "a",
  "button",
  "img",
  "form",
];

export function createMotionTag(tag: string){
  return function MotionTag(props: Record<string, unknown>){
    const children = (props as { children?: React.ReactNode }).children;
    const [RealComp, setRealComp] = React.useState<React.ElementType | null>(null);

    React.useEffect(() => {
      let mounted = true;
      import('framer-motion')
        .then((m: unknown) => {
          if (!mounted) return;
          const mm = m as FMModule;
          const maybe = mm?.motion?.[tag];
          if (maybe) setRealComp(() => maybe as React.ElementType);
        })
        .catch((e) => { void e; });
      return () => { mounted = false; };
    }, []);

    if(RealComp){
      return React.createElement(RealComp, props, children);
    }

    const Element: React.ElementType = tag;
    return React.createElement(Element, stripAnimProps(props), children);
  };
}
